import { render, staticRenderFns } from "./EnqueteTab.vue?vue&type=template&id=32019b7d&"
import script from "./EnqueteTab.vue?vue&type=script&lang=js&"
export * from "./EnqueteTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports